import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ProForm, ProFormText } from "@ant-design/pro-components";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { App, Card } from "antd";
import { api } from "@/api";

export default function LoginPage() {
  const nav = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200">
      <Card className="w-full max-w-md">
        <App>
          <InnerLogin
            formRef={formRef}
            loading={loading}
            setLoading={setLoading}
            navTo={from}
          />
        </App>
      </Card>
    </div>
  );
}

function InnerLogin({ formRef, loading, setLoading, navTo }) {
  const { message } = App.useApp();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      // нормалізуємо email
      const payload = { ...values, email: String(values.email || "").trim().toLowerCase() };

      const { data } = await api.post("/auth/login", payload);
      localStorage.setItem("auth_user", JSON.stringify(data.user));
      localStorage.setItem("auth_token", data.access_token);
      message.success("Ласкаво просимо!");
      navigate(navTo, { replace: true });
    } catch (e) {
      const detail =
        e?.response?.data?.detail ||
        e?.message ||
        "Невірні облікові дані";

      // підсвічаємо обидва поля
      formRef.current?.setFields?.([
        { name: "email", errors: [detail] },
        { name: "password", errors: [detail] },
      ]);

      // тост
      message.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h1 className="text-xl font-semibold mb-4 text-center">Вхід до системи</h1>
      <ProForm
        formRef={formRef}
        onFinish={onFinish}
        submitter={{
          searchConfig: { submitText: "Увійти" },
          submitButtonProps: { loading },
        }}
      >
        <ProFormText
          name="email"
          fieldProps={{ size: "large", prefix: <MailOutlined /> }}
          placeholder="Електронна пошта"
          rules={[
            { required: true, message: "Введіть електронну пошту" },
            { type: "email", message: "Некоректна адреса електронної пошти" },
          ]}
        />
        <ProFormText.Password
          name="password"
          fieldProps={{ size: "large", prefix: <LockOutlined /> }}
          placeholder="Пароль"
          rules={[{ required: true, message: "Введіть пароль" }]}
        />
      </ProForm>
    </>
  );
}
